import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CircularProgress
} from '@mui/material';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { handleDownload } from 'src/utils/handleDownload';
import FileUploaderSingle from '../../components/upload/FileUploaderSingle';
import { apiService } from '../../api/axiosClient';
import DropzoneWrapper from '../../styles/react-dropzone';

const UserDictCard = props => {
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])

    const handleDicSubmit = async (event) => {
        event.preventDefault();

        if(files.length == 0) {
            toast.error('No file selection', {
                position: "top-center"
            })
            return false
        }

        setLoading(true)

        const [file] = files;
        const formData = new FormData();
        formData.append('file', file, 'userdict.txt');

        try {
            await apiService.post('/admin/search/userdict', formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            toast.success('업데이트 되었습니다.')
            setFiles([])
        } catch (error) {
            toast.error('업데이트 실패했습니다.')
            console.error('Error updating userdict:', error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <Card>
            <CardHeader title='사용자 사전 관리' titleTypographyProps={{ variant: 'h6' }} />                        
            <CardContent>
                <Alert severity='info' sx={{mb:4}}>단어 등록은 한줄에 하나씩 추가해주세요</Alert>
                <form onSubmit={handleDicSubmit} id="dictform">
                    <DropzoneWrapper>
                        <FileUploaderSingle files={files} setFiles={setFiles} filetype={'text'}/>
                    </DropzoneWrapper>
                                                    
                </form>
            </CardContent>
            <CardActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'left' }}>
                <Button type="submit" form="dictform" variant='contained' sx={{mr:4}}>
                    {loading ? (
                        <CircularProgress
                            sx={{
                                color: 'common.white',
                                width: '20px !important',
                                height: '20px !important',
                                mr: theme => theme.spacing(2)
                            }}
                        />
                    ) : null}
                    등록
                </Button>
                <Button variant='contained' color='success'
                    onClick={()=>handleDownload(`${process.env.REACT_APP_FILE_URL}/opensearch/userdict.txt`, 'userdict.txt')}>
                    Download
                </Button>
            </CardActions>
        </Card>
    )
}

export default UserDictCard